export const petal = {
    petalLightest: '#fdf6f9',
    petalLight: '#f7dfe9',
    petal: '#eebed4',
    petalDark: '#a17187',
    petalDarkest: '#624b52',
};
